import '../components/UI/UIElements/UIElements.less';
import '../dev/js/core/polyfills';

import axios from 'axios';
import 'simplebar'; // or "import SimpleBar from 'simplebar';" if you want to use it manually.
import 'simplebar/dist/simplebar.css';

import { getLang } from "../dev/js/core/Helpers/Helpers";
import yall from 'yall-js/dist/yall.js';
import imgToSvg from "../dev/js/core/Helpers/imgToSvg";

class Page {
    
    constructor(){
	    document.addEventListener("DOMContentLoaded", () => {
		    yall({
			    observeChanges: true
		    });

		    imgToSvg();
		
		    // let imgDefer = document.getElementsByTagName('img');
		    // for (let i = 0; i < imgDefer.length; i++) {
		    // 	imgDefer[i].classList.add('vis');
		    // }
	    });
        
        let langAddress = `cache/_translations/${getLang()}.json`;
        
        let lang = axios.get(langAddress);
    
        lang.then(response => {
            localStorage.setItem('lang', JSON.stringify(response.data));
        
        }).catch(error => {
            error.response.status === 404
                ? console.log('[Sorry, we could not get language file. Something went wrong.]', error.response.status)
                : console.log('[Something is wrong with language processing.]');
        });
	
		// $(document).ready(function(){
		// 	let scrollPoint;
		// 	// window.addEventListener('load resize scroll') {
		// 	//
		// 	// }
		// 	$(window).on('load resize scroll', function(){
		//
		// 		scrollPoint = $("#bottom").position().top - $(window).height() + $("#promoBanner").outerHeight();
		//
		// 		if($(window).scrollTop() > scrollPoint){
		// 			$('#promoBanner').css({
		// 				'position' : 'relative',
		// 				'top' : 0,
		// 				'bottom' : ''
		// 			});
		// 		}else{
		// 			$('#promoBanner').css({
		// 				'position' : 'fixed',
		// 				'top' : '',
		// 				'bottom' : 0
		// 			});
		// 		}
		// 	});
		// });
    }
}

export default Page;



// WEBPACK FOOTER //
// ../extendable/Page.js